/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { auditlogsList } from "../funcs/auditlogsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListAuditLogsRequest,
  ListAuditLogsResponse,
  ListAuditLogsSecurity,
} from "../models/operations/listauditlogs.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type AuditLogsQueryData = ListAuditLogsResponse;

export type AuditLogsInfiniteQueryData = PageIterator<
  ListAuditLogsResponse,
  { cursor: string }
>;

export type AuditLogsPageParams = PageIterator<
  ListAuditLogsResponse,
  { cursor: string }
>["~next"];

export function prefetchAuditLogs(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAuditLogsRequest | undefined,
  security?: ListAuditLogsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAuditLogsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchAuditLogsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAuditLogsRequest | undefined,
  security?: ListAuditLogsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildAuditLogsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as AuditLogsPageParams,
    getNextPageParam: (previousPage: AuditLogsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildAuditLogsQuery(
  client$: GramCore,
  request?: ListAuditLogsRequest | undefined,
  security?: ListAuditLogsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AuditLogsQueryData>;
} {
  return {
    queryKey: queryKeyAuditLogs({
      cursor: request?.cursor,
      projectSlug: request?.projectSlug,
      actorId: request?.actorId,
      action: request?.action,
      subjectType: request?.subjectType,
      subjectId: request?.subjectId,
      subjectIds: request?.subjectIds,
      actingSurface: request?.actingSurface,
      from: request?.from,
      to: request?.to,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function auditLogsQueryFn(ctx): Promise<AuditLogsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(auditlogsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildAuditLogsInfiniteQuery(
  client$: GramCore,
  request?: ListAuditLogsRequest | undefined,
  security?: ListAuditLogsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, AuditLogsPageParams>,
  ) => Promise<AuditLogsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyAuditLogsInfinite({
      cursor: request?.cursor,
      projectSlug: request?.projectSlug,
      actorId: request?.actorId,
      action: request?.action,
      subjectType: request?.subjectType,
      subjectId: request?.subjectId,
      subjectIds: request?.subjectIds,
      actingSurface: request?.actingSurface,
      from: request?.from,
      to: request?.to,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function auditLogsQuery(
      ctx,
    ): Promise<AuditLogsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(auditlogsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(auditlogsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyAuditLogs(
  parameters: {
    cursor?: string | undefined;
    projectSlug?: string | undefined;
    actorId?: string | undefined;
    action?: string | undefined;
    subjectType?: string | undefined;
    subjectId?: string | undefined;
    subjectIds?: Array<string> | undefined;
    actingSurface?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "auditlogs", "list", parameters];
}

export function queryKeyAuditLogsInfinite(
  parameters: {
    cursor?: string | undefined;
    projectSlug?: string | undefined;
    actorId?: string | undefined;
    action?: string | undefined;
    subjectType?: string | undefined;
    subjectId?: string | undefined;
    subjectIds?: Array<string> | undefined;
    actingSurface?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "auditlogs", "list", "infinite", parameters];
}
